import React from 'react';
import { modelData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Logo */}
          <div className="mb-6 md:mb-0">
            <span className="text-white font-light tracking-[0.3em] text-lg">
              {modelData.name.toUpperCase()}
            </span>
          </div>

          {/* Preferred411 Badge */}
          <div className="mb-6 md:mb-0">
            <a href="https://preferred411.com/admirer/register?ref=80370" target="_blank" rel="noopener noreferrer">
              <img 
                src="https://preferred411.com/a/preferredSeal-p.png" 
                width="109" 
                height="119" 
                alt="Preferred411.com"
                className="hover:opacity-80 transition-opacity duration-300"
              />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center md:text-right">
            <p className="text-white/40 text-sm tracking-wide">
              © {currentYear} {modelData.name}. All rights reserved.
            </p>
            <p className="text-white/20 text-xs mt-1">
              Professional Modeling Portfolio
            </p>
          </div>
        </div>
      </div>

      {/* Top gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </footer>
  );
};

export default Footer;
